import { ReactElement } from "react";

import {
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  useBreakpointValue,
} from "@chakra-ui/react";

import TextHeading from "components/TextHeading";
import { AveragePricingFormWrapper } from "forms/pricing/average-pricing";
import { CARD_MAX_WIDTH, desktopOnly } from "utils/styleHelpers";

const AddAveragePricingModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}): ReactElement => {
  const isCentered = useBreakpointValue(desktopOnly);

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered={isCentered}>
      <ModalOverlay />
      <ModalContent maxW={CARD_MAX_WIDTH}>
        <ModalHeader pb={6}>
          <TextHeading headingType="h3">Average Pricing</TextHeading>
        </ModalHeader>
        <ModalBody>
          <AveragePricingFormWrapper onClose={onClose} />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default AddAveragePricingModal;
